module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navbar-expand-md"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-tree-conifer"
  }), _vm._v("\n        Predictive Deer Tracker\n      ")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_vm._v("Home")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/tracking"
    }
  }, [_c('a', [_vm._v("Tracking")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/gallery"
    }
  }, [_c('a', [_vm._v("Gallery")])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/login"
    }
  }, [_c('a', [_c('span', {
    staticClass: "glyphicon glyphicon-user"
  }), _vm._v(" Sign Up")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "to": "/login"
    }
  }, [_c('a', [_c('span', {
    staticClass: "glyphicon glyphicon-log-in"
  }), _vm._v(" Login")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-427a9fc7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 373
// module chunks = 2